import './video_player.scss';

import React from 'react';

interface Props {
  url: string;
  type: string;
}

export function VideoPlayer({ url, type }: Props): JSX.Element {
  return (
    <video className="video-player" controls>
      <source src={url} type={type} />
    </video>
  );
}
